<template>
  <img
    :src="global.logo"
    alt=""
    width="150"
    height="100"
  >
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapGetters } from 'vuex';

export default defineComponent({
  name: 'Logo',
  computed: {
    ...mapGetters([
      'global'
    ])
  }
});
</script>
